import request from "@/plugins/axios";

// 订单列表其他列表参数
export const apiOtherLists = () =>
  request.get("/order.set_meal_order/searchParam");

// 订单详情
export const apiOrderDetail = (params: any) =>
  request.get("/order.set_meal_order/detail", { params });

// 订单列表
export const apiOrderLists = (params: any) =>
  request.get("/order.set_meal_order/lists", { params });

// 订单备注
export const apiOrderRemarks = (params: any) =>
  request.post("/order.set_meal_order/remark", params);

// 确认支付
export const apiOrderConfirmPay = (params: any) =>
  request.post("/order.set_meal_order/confirmPay", params);

export const apiFactoryOrderLists = (params: any) =>
  request.get("/order.shopOrder/lists", { params });

// 生产订单列表
export const apiOrderShopOrderLists = (params: any) =>
  request.get("/order.shopOrder/lists", { params });

// 商城服务使用记录
export const apiShopShopOrderStatistics = (params: any) =>
  request.get("/shop.shop/orderStatistics", { params });

export const apiShopOrderDetail = (params: any) =>
  request.get("/order.shopOrder/detail", { params });

export const apiShopOrderLog = (params: any) =>
  request.get("/order.shopOrder/log", { params });

export const apiReturnOrderList = (params: any) =>
  request.get("/order.order/getReturnOrderList", { params });

export const apiTransferLogList = (params: any) =>
  request.get("/order.order/getTransferLogList", { params });
